import { platformBrowser }    from '@angular/platform-browser';
import { BrowserAppModuleNgFactory } from './ngfactory/app/browser-app.module.ngfactory';
import {enableProdMode} from "@angular/core";

enableProdMode();

platformBrowser().bootstrapModuleFactory(BrowserAppModuleNgFactory);



// WEBPACK FOOTER //
// ./src/main.browser.aot.ts